<section class="section-main">
    <mat-accordion class="custom-accordion" multi>
        <mat-expansion-panel class="custom-panel">
            <mat-expansion-panel-header class="custom-header">
                <mat-panel-title class="custom-title"> <mat-icon>history</mat-icon> &nbsp; Communication History
                    Timeline
                </mat-panel-title>
            </mat-expansion-panel-header>

            <div *ngFor="let history of communicationHistory; let i = index" class="history-item">
                <div class="history-card">
                    <div class="status-indicator">
                        <mat-icon class="status-icon">check_circle</mat-icon>
                    </div>
                    <div class="history-wrapper">
                        <div class="history-header">
                            <div class="history-content">
                                <div style="display: flex; flex-direction: row; align-items: center; gap: 10px;">
                                    <h6 class="history-title">{{ history.display_message }}</h6>
                                    <p class="history-message" *ngIf="hasValue(history.message)">{{ history.message }}
                                    </p>
                                </div>
                                <p style="font-size: 14px; color: var(--color-text-light-1); margin: 0; font-weight: 500;">
                                    {{ history.source_type }}
                                </p>
                                <p class="history-meta">
                                    <mat-icon class="meta-icon">schedule</mat-icon>
                                    {{ history.created_on | date: 'dd-MMM-yyyy HH:mm' }} • {{ history.created_by }}
                                </p>
                                <p class="history-meta" *ngIf="hasValue(history.email_to)">
                                    <mat-icon class="meta-icon">email</mat-icon>
                                    Email To: {{ history.email_to }}
                                </p>
                                <p class="history-meta" *ngIf="hasValue(history.email_cc)">
                                    <mat-icon class="meta-icon">email</mat-icon>
                                    Email CC: {{ history.email_cc }}
                                </p>
                            </div>
                            <button mat-icon-button class="info-btn" *ngIf="isExpandable(history)"
                                (click)="toggleExpand(i); $event.stopPropagation()">
                                <mat-icon>{{ expandedItems[i] ? 'info' : 'info_outline' }}</mat-icon>
                            </button>
                        </div>

                        <!-- Expanded Content -->
                        <div class="history-details"
                            *ngIf="expandedItems[i] && (hasModifiedData(history) || hasFiles(history))" [@slideDown]>

                            <!-- Vessel Modifications Section -->
                            <div class="nested-section" *ngIf="getVesselProperties(history).length > 0">
                                <div class="nested-header">
                                    <div class="nested-summary">
                                        <strong>Vessel Modifications</strong>
                                        <span class="summary-text" *ngIf="getVesselSummary(history).length > 0">
                                            <ng-container
                                                *ngFor="let summary of getVesselSummary(history); let last = last">
                                                <span
                                                    *ngFor="let line of splitSummaryLines(summary); let lastLine = last"
                                                    class="summary-item">
                                                    <mat-icon class="summary-bullet-icon">arrow_right</mat-icon>
                                                    {{ line }}<span *ngIf="!lastLine"><br></span>
                                                </span>
                                                <span *ngIf="!last"></span>
                                            </ng-container>
                                        </span>
                                    </div>
                                    <button mat-icon-button class="nested-info-btn" (click)="toggleVessel(i)">
                                        <mat-icon>{{ vesselExpanded[i] ? 'info' : 'info_outline' }}</mat-icon>
                                    </button>
                                </div>
                                <div class="nested-content" *ngIf="vesselExpanded[i]" [@slideDown]>
                                    <div class="compact-table">
                                        <div class="compact-table-header">
                                            <div class="compact-cell">Field Name</div>
                                            <div class="compact-cell">Previous Value</div>
                                            <div class="compact-cell">Current Value</div>
                                        </div>
                                        <div class="compact-table-row"
                                            *ngFor="let prop of getVesselProperties(history)">
                                            <div class="compact-cell">{{ prop.field }}</div>
                                            <div class="compact-cell">{{ prop.old_value ?? 'N/A' }}</div>
                                            <div class="compact-cell">{{ prop.new_value ?? 'N/A' }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Meraki Modifications Section -->
                            <div class="nested-section" *ngIf="getMerakiServices(history).length > 0">
                                <div class="nested-header">
                                    <div class="nested-summary">
                                        <strong>Meraki Changes</strong>
                                        <span class="summary-text" *ngIf="getMerakiSummary(history).length > 0">
                                            <ng-container
                                                *ngFor="let summary of getMerakiSummary(history); let last = last">
                                                <span
                                                    *ngFor="let line of splitSummaryLines(summary); let lastLine = last"
                                                    class="summary-item">
                                                    <mat-icon class="summary-bullet-icon">arrow_right</mat-icon>
                                                    {{ line }}<span *ngIf="!lastLine"><br></span>
                                                </span>
                                                <span *ngIf="!last"><br></span>
                                            </ng-container>
                                        </span>
                                    </div>
                                    <button mat-icon-button class="nested-info-btn" (click)="toggleMeraki(i)">
                                        <mat-icon>{{ merakiExpanded[i] ? 'info' : 'info_outline' }}</mat-icon>
                                    </button>
                                </div>
                                <div class="nested-content" *ngIf="merakiExpanded[i]" [@slideDown]>
                                    <div class="compact-table">
                                        <div class="compact-table-header"
                                            [style.grid-template-columns]="hasMerakiMovements(history) ? '1fr 1fr 1fr' : '1fr 1fr'">
                                            <div class="compact-cell">Service Name</div>
                                            <div class="compact-cell" *ngIf="hasMerakiMovements(history)">Movement
                                                Changes</div>
                                            <div class="compact-cell">Other Changes</div>
                                        </div>
                                        <div class="compact-table-row"
                                            [style.grid-template-columns]="hasMerakiMovements(history) ? '1fr 1fr 1fr' : '1fr 1fr'"
                                            *ngFor="let service of getMerakiServices(history)">
                                            <div class="compact-cell">
                                                <div style="font-weight: 600;">{{ service.service_name }}</div>
                                            </div>
                                            <div class="compact-cell" *ngIf="hasMerakiMovements(history)">
                                                <div *ngIf="service.movement && service.movement.length > 0">
                                                    <div *ngFor="let mov of service.movement"
                                                        style="margin: 4px 0; padding: 6px 10px; background: var(--color-bg-dark-2); border-radius: 4px; font-weight: 500;">
                                                        <strong>{{ mov.subservice_name }}:</strong>&nbsp;
                                                        <span style="color: var(--app-status-error);">{{ mov.old_value }}</span> &nbsp;
                                                        <mat-icon
                                                            style="font-size: 14px; width: 14px; height: 14px; vertical-align: middle; color: var(--color-action);">arrow_forward</mat-icon>
                                                        &nbsp;
                                                        <span style="color: var(--color-success);">{{ mov.new_value }}</span>
                                                    </div>
                                                </div>
                                                <div *ngIf="!service.movement || service.movement.length === 0"
                                                    style="color: #999;">
                                                    N/A
                                                </div>
                                            </div>
                                            <div class="compact-cell">
                                                <div *ngIf="service.optional" style="margin-bottom: 4px;">
                                                    <strong>Optional:</strong> {{ service.optional }}
                                                </div>
                                                <div *ngIf="service.required" style="margin-bottom: 4px;">
                                                    <strong>Required:</strong> {{ service.required }}
                                                </div>
                                                <div *ngIf="service.total_change"
                                                    style="margin-top: 4px; padding: 6px 10px; background: var(--color-bg-dark-2); border-radius: 4px; font-weight: 500;">
                                                    <strong>Total Changed:</strong>&nbsp;
                                                    <span style="color: var(--app-status-error);">{{ service.total_change.old_total
                                                        }}</span> &nbsp;
                                                    <mat-icon
                                                        style="font-size: 14px; width: 14px; height: 14px; vertical-align: middle; color: var(--color-action);">arrow_forward</mat-icon>
                                                    &nbsp;
                                                    <span style="color: var(--color-success);">{{ service.total_change.new_total
                                                        }}</span>
                                                </div>
                                                <div *ngIf="!service.optional && !service.required && !service.total_change"
                                                    style="color: #999;">
                                                    N/A
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Port Agent Modifications Section -->
                            <div class="nested-section"
                                *ngIf="getPortAgentServices(history).length > 0 || hasPortAgentAgreedOrNegotiate(history)">
                                <div class="nested-header">
                                    <div class="nested-summary">
                                        <strong>Port Agent Changes</strong>
                                        <span class="summary-text" *ngIf="getPortAgentSummary(history).length > 0">
                                            <ng-container
                                                *ngFor="let summary of getPortAgentSummary(history); let last = last">
                                                <span
                                                    *ngFor="let line of splitSummaryLines(summary); let lastLine = last"
                                                    class="summary-item">
                                                    <mat-icon class="summary-bullet-icon">arrow_right</mat-icon>
                                                    {{ line }}<span *ngIf="!lastLine"><br></span>
                                                </span>
                                                <span *ngIf="!last"><br></span>
                                            </ng-container>
                                        </span>
                                    </div>
                                    <button mat-icon-button class="nested-info-btn" (click)="togglePortAgent(i)">
                                        <mat-icon>{{ portAgentExpanded[i] ? 'info' : 'info_outline' }}</mat-icon>
                                    </button>
                                </div>
                                <div class="nested-content" *ngIf="portAgentExpanded[i]" [@slideDown]>
                                    <!-- Show Services Table if services exist -->
                                    <div class="compact-table" *ngIf="getPortAgentServices(history).length > 0">
                                        <div class="compact-table-header">
                                            <div class="compact-cell">Service Name</div>
                                            <div class="compact-cell">Actions</div>
                                        </div>
                                        <div class="compact-table-row"
                                            *ngFor="let service of getPortAgentServices(history)">
                                            <div class="compact-cell">{{ service.service_name }}</div>
                                            <div class="compact-cell">
                                                <ul class="compact-list">
                                                    <li *ngFor="let msg of service.message">{{ msg }}</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Show Agreed/Negotiate Table if data exists -->
                                    <div class="compact-table" *ngIf="hasPortAgentAgreedOrNegotiate(history)"
                                        style="margin-top: 12px;">
                                        <div class="compact-table-header" style="grid-template-columns: 1fr 1fr;">
                                            <div class="compact-cell">Agreed Services</div>
                                            <div class="compact-cell">Negotiate Services</div>
                                        </div>
                                        <div class="compact-table-row" style="grid-template-columns: 1fr 1fr;">
                                            <div class="compact-cell">
                                                <div *ngIf="getPortAgentAgreed(history).length > 0">
                                                    <div *ngFor="let service of getPortAgentAgreed(history)"
                                                        style="margin: 4px 0; padding: 6px 10px; background: var(--color-bg-dark-2); border-radius: 4px; font-weight: 500; color: var(--color-success); display: inline-flex; align-items: center; gap: 6px;">
                                                        <mat-icon
                                                            style="font-size: 16px; width: 16px; height: 16px; color: var(--color-success);">check_circle</mat-icon>
                                                        {{ service }}
                                                    </div>
                                                </div>
                                                <div *ngIf="getPortAgentAgreed(history).length === 0"
                                                    style="color: #999; font-style: italic;">
                                                    No agreed services
                                                </div>
                                            </div>
                                            <div class="compact-cell">
                                                <div *ngIf="getPortAgentNegotiate(history).length > 0">
                                                    <div *ngFor="let service of getPortAgentNegotiate(history)"
                                                        style="margin: 4px 0; padding: 6px 10px; background: var(--color-bg-dark-2); border-radius: 4px; font-weight: 500; color: var(--app-status-warning); display: inline-flex; align-items: center; gap: 6px;">
                                                        <mat-icon
                                                            style="font-size: 16px; width: 16px; height: 16px; color: var(--app-status-warning);">sync</mat-icon>
                                                        {{ service }}
                                                    </div>
                                                </div>
                                                <div *ngIf="getPortAgentNegotiate(history).length === 0"
                                                    style="color: #999; font-style: italic;">
                                                    No negotiate services
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Client Modifications Section -->
                            <div class="nested-section" *ngIf="getClientServices(history).length > 0">
                                <div class="nested-header">
                                    <div class="nested-summary">
                                        <strong>Client Changes</strong>
                                        <span class="summary-text" *ngIf="getClientSummary(history).length > 0">
                                            <ng-container
                                                *ngFor="let summary of getClientSummary(history); let last = last">
                                                <span
                                                    *ngFor="let line of splitSummaryLines(summary); let lastLine = last"
                                                    class="summary-item">
                                                    <mat-icon class="summary-bullet-icon">arrow_right</mat-icon>
                                                    {{ line }}<span *ngIf="!lastLine"><br></span>
                                                </span>
                                                <span *ngIf="!last"><br></span>
                                            </ng-container>
                                        </span>
                                    </div>
                                    <button mat-icon-button class="nested-info-btn" (click)="toggleClient(i)">
                                        <mat-icon>{{ clientExpanded[i] ? 'info' : 'info_outline' }}</mat-icon>
                                    </button>
                                </div>
                                <div class="nested-content" *ngIf="clientExpanded[i]" [@slideDown]>
                                    <div class="compact-table">
                                        <div class="compact-table-header">
                                            <div class="compact-cell">Service Name</div>
                                            <div class="compact-cell">Message</div>
                                        </div>
                                        <div class="compact-table-row"
                                            *ngFor="let service of getClientServices(history)">
                                            <div class="compact-cell">{{ service.service_name }}</div>
                                            <div class="compact-cell">{{ service.message || 'N/A' }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Attached Files Section -->
                            <div class="nested-section" *ngIf="history.files && history.files.length > 0">
                                <div class="nested-header">
                                    <div class="nested-summary">
                                        <strong>Attached Files</strong>
                                        <span class="summary-text">
                                            {{ history.files.length }} file(s) attached
                                        </span>
                                    </div>
                                </div>
                                <div class="nested-content">
                                    <div class="compact-table">
                                        <div class="compact-table-header">
                                            <div class="compact-cell">Filename</div>
                                            <div class="compact-cell">Description</div>
                                            <div class="compact-cell">Source Type</div>
                                            <div class="compact-cell">Action</div>
                                        </div>
                                        <div class="compact-table-row" *ngFor="let file of history.files">
                                            <div class="compact-cell">{{ file.name || 'N/A' }}</div>
                                            <div class="compact-cell">{{ file.description || 'N/A' }}</div>
                                            <div class="compact-cell">{{ file.source_type || 'N/A' }}</div>
                                            <div class="compact-cell">
                                                <button *ngIf="file.complete_file_path" (click)="getUploadedFiles(history.comm_history_id, file.file_id)"
                                                    class="file-view-btn">
                                                    <mat-icon>visibility</mat-icon> View
                                                </button>
                                                <span *ngIf="!file.complete_file_path">N/A</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </mat-expansion-panel>
    </mat-accordion>
</section>